<template>
    <v-card>
        <v-card-title class="text-h5 bg-grey-lighten-2" primary-title style="display: relative">
            Upload {{ fileDescription }} for {{ requestCode }}
        </v-card-title>
        <v-card-text>
            <v-file-input v-model="file" accept=".xlsx" label="Select XLSX file"></v-file-input>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancel" color="primary">Cancel</v-btn>
            <v-btn @click="submit" :disabled="!file" color="primary">Upload</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: "UploadRequestFile",
    props: {
        requestCode: String,
        fileDescription: String,
    },
    data() {
        return {
            file: null,
        };
    },
    methods: {
        cancel() {
            this.file = null;
            this.$emit("close");
        },
        submit() {
            this.$emit("submit", this.file);
        },
    },
};
</script>
